import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../signalmentAction';
import fetchApi from "./fetchApi";

function fetchSignalmentAction() {
  return fetchApi('/v1/fc_api/signalment_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchSignalmentAction;
